import { render, staticRenderFns } from "./dashboard.html?vue&type=template&id=52512e4c&scoped=true&"
import script from "./dashboard.js?vue&type=script&lang=js&"
export * from "./dashboard.js?vue&type=script&lang=js&"
import style0 from "./dashboard.scss?vue&type=style&index=0&id=52512e4c&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "52512e4c",
  null
  
)

export default component.exports